import clsx from "clsx";
import React from "react";
import { Link } from "react-router-dom";

interface HashtagProps {
  text: string;
  icon?: string;
  iconSrc?: string;
  link: string;
  className?: string;
}

const Hashtag = ({
  text,
  icon,
  link,
  className,
  iconSrc,
}: HashtagProps): JSX.Element => {
  return (
    <Link
      to={link}
      className={clsx(
        "flex items-center justify-center leading-[120%] cursor-pointer w-[154px] tracking-tighter rounded-full bg-white font-bold h-[45px] border border-solid border-[2px] border-transparent hover:border-red-500 transition-all duration-200",
        "md:text-lg md:text-base md:h-[51px]",
        "lg:text-2xl lg:h-[58px]",
        "2xl:text-4xl 2xl:h-[83px]",
        className
      )}
    >
      <span className="mr-[10px]">{text}</span>
      {icon && (
        <span className="h-[21px] md:h-[23px] lg:h-[30px] 2xl:h-[43px]">
          {icon}
        </span>
      )}
      {iconSrc && (
        <img
          src={iconSrc}
          alt={text}
          className="w-[16px] h-auto md:w-[18px] lg:w-[24px] 2xl:w-[36px]"
        />
      )}
    </Link>
  );
};

export default Hashtag;
